import React from 'react';
import { Modal } from 'react-bootstrap';
const NonSubscriberLoginComponent = (props) => {
  let data = (props.pageData && props.pageData.data) ? props.pageData.data : null;
  
  return (
    data ?
      <Modal show={true} onHide={props.onHide}>
        <Modal.Header>
          <Modal.Title className="popup-title text-center">
            <div> {(data.label1) ? data.label1 : ''}</div>
            <div>{(data.label1) ? data.label2 : ''}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <a href={data.docomoLogin.url + "?relogin="+props.token+"&redirect_url="+props.redirect_url } className="login-gray"><img src="/images/pcBtn68_white.png" alt="login" /></a>
         
          <a href={data && data.subscriptionPage.PC_URL} id="PClink" tabIndex="-1" data-name="catSearchBtn" type="button" className="bg-gray cat-search-btn btn btn-outline-secondary login-red btn-lg d-none d-lg-block d-md-block d-xl-block">{data && data.subscriptionPage.label}</a>

          <a href={data && data.subscriptionPage.Mobile_URL} id="mobileLink" tabIndex="-1" data-name="catSearchBtn" type="button" className="bg-gray cat-search-btn btn btn-outline-secondary login-red btn-lg d-block d-lg-none d-md-none d-xl-none">{data && data.subscriptionPage.label}</a>

        </Modal.Body>
        <Modal.Footer >
          <a href={data && data.topPage.url} disabled="" id="submitBtn" tabIndex="0" data-name="catSearchBtn" type="button">{data && data.topPage.label}</a>
        </Modal.Footer>
      </Modal>
      : ''
  );
};
export default NonSubscriberLoginComponent;